/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateCurrencyAdd } from '../../assets/validation';
import CurrencyAction from '../../store/actions/CurrencyAction';

function CurrencyEdit({ itemId, openmodal, onCloseModal }) {
  const dispatch = useDispatch();
  // Replace 'data' with your reducer name
  const { currencyItemData } = useSelector((state) => state.currency);
  useEffect(() => {
    dispatch(CurrencyAction.getItem(itemId));
  }, [dispatch, itemId]);

  // useEffect(() => {
  //   if (listData) {
  //     if (listData.data) {
  //       setData(listData.data);
  //     } else {
  //       setData([]);
  //     }
  //     setRowCountState((prevRowCountState) =>
  //       listData.total !== undefined ? listData.total : prevRowCountState
  //     );
  //   }
  // }, [listData]);

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      //   aria-labelledby="modal-modal-title"
      //   aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            name: currencyItemData && currencyItemData.name ? currencyItemData.name : '',
            symbol: currencyItemData && currencyItemData.symbol ? currencyItemData.symbol : '',
            short_name:
              currencyItemData && currencyItemData.short_name ? currencyItemData.short_name : '',
            status_name:
              currencyItemData && currencyItemData.status_name ? currencyItemData.status_name : ''
          }}
          enableReinitialize
          validationSchema={ValidateCurrencyAdd}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            // console.log(values, "values");
            dispatch(CurrencyAction.add(values, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({ values, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="View Currency"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="Currency"
                    disabled
                    name="name"
                    margin="normal"
                    value={values.name}
                    required={false}
                  />
                  <TextField
                    id="symbol"
                    fullWidth
                    label="Currency Symobol"
                    disabled
                    name="symbol"
                    margin="normal"
                    value={values.symbol}
                    required={false}
                  />
                  <TextField
                    id="short_name"
                    fullWidth
                    label="Currency Short Name"
                    disabled
                    name="short_name"
                    margin="normal"
                    value={values.short_name}
                    required={false}
                  />
                  <TextField
                    id="status_name"
                    fullWidth
                    label="Status"
                    disabled
                    name="status_name"
                    margin="normal"
                    value={values.status_name}
                    required={false}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      onCloseModal();
                    }}
                  >
                    Close
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
CurrencyEdit.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default CurrencyEdit;
